import React from 'react';
import {DmsTab} from 'Components';
import {Form, Input, Select, Button, Row, Col, Tree, message} from 'antd';
import {jobTree, jobDetail, jobAdd, jobModify, jobDelete} from '../../service/job';
import {nameValidator,checkCode} from '../../utils/regexp.js';
const Option = Select.Option;
const FormItem = Form.Item;
const TreeNode = Tree.TreeNode;
import {showSpin,hideSpin} from 'Utils';

class Job extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['岗位管理'],
			tree: [],
			selectkey: null,
			detail: {},
			editFlag:false,//编辑
			rootFlag:false,//上一级
			childFlag:false,//下一级
			buttonFlag:true,//按钮
			disabledFlag:true,
			hasFeedback:false,
			keys:[]
		};
		this.onSelect = this.onSelect.bind(this);
		this.getData = this.getData.bind(this);
	}
	
	componentDidMount() {
		this.getData();
	}
	
	getData() {
		jobTree({id: 0}).then(result => {
			if (result.status) {
				this.setState({
					tree: result.data
				})
			} else {
				message.error(result.message);
			}
		})
	}
	
	//编辑
	editHandle() {
		if(this.state.selectkey!=null){
			this.setState({
				childFlag:false,
				editFlag:true,
				rootFlag:false,
				disabledFlag:false,
				hasFeedback:true
			});
		}else{
			this.cancelHandle();
		}
	}
	
	
	//删除
	deleteHandle() {
		if(this.state.selectkey!=null){
			jobDelete({id: this.state.detail.id}).then(result => {
				if (result.status) {
					message.success('删除成功');
					this.getData();
					this.cancelHandle();
				}else{
					message.error(result.message);
				}
			})
		}else{
			message.info('请选择要删除的岗位');
		}
	}
	
	//添加上一级
	upSumbit() {
		this.setState({
			childFlag:false,
			editFlag:false,
			rootFlag:true,
			disabledFlag:false,
			keys:[],
			hasFeedback:true
		});
		const {setFieldsValue} = this.props.form;
		setFieldsValue({
			name: '',
			code: '',
			active: ''
		});
	}
	
	
	//添加下一级
	downSumbit() {
		if(this.state.selectkey!=null){
			this.setState({
				childFlag:true,
				editFlag:false,
				rootFlag:false,
				disabledFlag:false,
				hasFeedback:true
			});
			const {setFieldsValue} = this.props.form;
			setFieldsValue({
				name: '',
				code: '',
				active: ''
			});
		}else{
			this.setState({
				childFlag:false,
				editFlag:false,
				rootFlag:false,
				disabledFlag:true,
				hasFeedback:false
			})
			message.info('请选择上级组织');
		}
	}
	
	
	onSelect(selectedKeys, info) {
		this.setState({
			keys:selectedKeys,
			childFlag:false,
			editFlag:false,
			rootFlag:false,
			buttonFlag:false,
			disabledFlag:true,
			hasFeedback:false
		});
		if (selectedKeys.length != 0) {
			const {setFieldsValue} = this.props.form;
			jobDetail({id: parseInt(selectedKeys[0],0)}).then(result => {
				if (result.status) {
					if (result.data.active === 1) {
						result.data.active = '有效';
					} else {
						result.data.active = '无效';
					}
					this.setState({
						detail: result.data,
						selectkey:parseInt(selectedKeys[0],0)
					})
					setFieldsValue({
						name: result.data.name,
						code: result.data.code,
						active: result.data.active
					});
				} else {
					message.error(result.message);
				}
			})
		}else{
			this.cancelHandle();
		}
	}
	
	cancelHandle() {
		this.setState({
			childFlag:false,
			editFlag:false,
			rootFlag:false,
			buttonFlag:true,
			disabledFlag:true,
			keys:[],
			hasFeedback:false
		});
		const {setFieldsValue} = this.props.form;
		setFieldsValue({
			name: '',
			code: '',
			active: ''
		});
	}
	
	submitHandle() {
		const {editFlag,childFlag,rootFlag}=this.state;
		if(editFlag===false&&childFlag===false&&rootFlag===false){
			message.info('请选择要进行何种操作');
		}else {
			const {validateFields, getFieldsValue} = this.props.form;
			validateFields((errors) => {//表单校验
				if (errors) {
					return
				}//表单校验有误，则不执行下面的代码
				const data = {
					...getFieldsValue() //获取用户输入
				};
				if (data.active === '1' || data.active === '有效') {
					data.active = 1;
				} else {
					data.active = 0;
				}

        showSpin();
				if (editFlag === true && childFlag === false && rootFlag === false) {
					data.id = this.state.detail.id;
					data.parentId = this.state.detail.parentId;
					jobModify(data).then(result => {
						hideSpin();
						if (result.status) {
							this.getData();
							this.cancelHandle();
							message.success('修改成功');
						} else {
							message.error(result.message);
						}
					})
				}
				//新增上一级
				if (editFlag === false && childFlag === false && rootFlag === true) {
					data.parentId = 0;
					jobAdd(data).then(result => {
						hideSpin();
						if (result.status) {
							this.getData();
							this.cancelHandle();
							message.success('添加成功');
						} else {
							message.error(result.message);
						}
					})
				}
				//新增下一级
				if (editFlag === false && childFlag === true && rootFlag === false) {
					data.parentId = this.state.detail.id;
					jobAdd(data).then(result => {
						hideSpin();
						if (result.status) {
							this.getData();
							this.cancelHandle();
							message.success('添加成功');
						} else {
							message.error(result.message);
						}
					})
				}
				
			})
		}
		
	}
	
	
	render() {
		const {opts,disabledFlag,buttonFlag,keys,hasFeedback} = this.state;
		const {getFieldDecorator} = this.props.form;
		
		const loop = data => data.map((item, key) => {
			if (item.child && item.child.length) {
				return <TreeNode key={`${item.id}_${key}`} title={item.name}>{loop(item.child)}</TreeNode>;
			}
			return <TreeNode key={`${item.id}_${key}`} title={item.name}/>;
		});
		
		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.upSumbit.bind(this)}>+新增父岗位</Button>
				<Button disabled={buttonFlag} onClick={this.downSumbit.bind(this)}>+新增子岗位</Button>
				<Button disabled={buttonFlag} onClick={this.editHandle.bind(this)}>编辑当前岗位</Button>
				<Button disabled={buttonFlag} onClick={this.deleteHandle.bind(this)}>删除当前岗位</Button>
			</DmsTab>
			<div className="dms-table-box"
				 style={{backgroundColor: "#fff", padding: '20px 5% 20px 35%', minHeight: '350px'}}>
				
				<div className="left"
					 style={{
						 width: "27%",
						 display: 'inline-block',
						 height: '90%',
						 overflow: 'auto',
						 marginRight: '3%',
						 position: 'absolute',
						 left: '5%',
						 top: '20px'
					 }}>
					<Tree
						defaultExpandAll={true}
						onSelect={this.onSelect}
						selectedKeys={keys}
					>
						{loop(this.state.tree)}
					</Tree>
				</div>
				
				<div className='right' style={{width: "100%", display: 'inline-block'}}>
					<Form layout="horizontal">
						<Row gutter={16}>
							<Col className="gutter-row" span={12}>
								<FormItem label="名称" hasFeedback={hasFeedback}>
									{getFieldDecorator('name', {
										rules: [
											{
												required: true,
												message: '请输入岗位名称'
											},
											{
												validator: nameValidator
											}
										],
									})(<Input disabled={disabledFlag} placeholder="请输入岗位名称"/>)}
								</FormItem>
							</Col>
							<Col className="gutter-row" span={12}>
								<FormItem label="编码" hasFeedback={hasFeedback}>
									{getFieldDecorator('code', {
										rules: [
											{
												required: true,
												message: '请输入岗位编码'
											},
											{
												validator: checkCode
											}
										],
									})(<Input disabled={disabledFlag} placeholder="请输入岗位编码"/>)}
								</FormItem>
							</Col>
						</Row>
						
						<Row gutter={16}>
							<Col className="gutter-row" span={12}>
								<FormItem label="有效性">
									{getFieldDecorator('active', {
										rules: [
											{
												required: true,
												message: '请选择是否有效'
											},
										]
									})(<Select disabled={disabledFlag}>
										<Option value='1'>有效</Option>
										<Option value='0'>无效</Option>
									</Select>)}
								</FormItem>
							</Col>
						</Row>
					</Form>
					
					{
						disabledFlag?
							''
							:
							<div style={{textAlign:'center'}}>
								<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
								<Button style={{marginLeft:'20px'}} onClick={this.cancelHandle.bind(this)}>取消</Button>
							</div>
					}
				</div>
			
			</div>
		</div>
	}
}
export default Form.create()(Job)


// WEBPACK FOOTER //
// ./src/routes/job/index.js